import React, { useState, useRef, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaMoon, FaSun, FaBars, FaTimes, FaBullseye, FaPlus, FaChevronDown, FaUser, FaGolfBall } from 'react-icons/fa';
import './Header.css';

const Header = ({ toggleTheme, theme }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <FaBullseye className="logo-icon" />
            <span className="logo-text">ToggleBoys Ligan 2025</span>
          </Link>
        </div>

        <div className={`nav-container ${menuOpen ? 'active' : ''}`}>
          <nav className="main-nav">
            <NavLink to="/" onClick={closeMenu} end>
              Hem
            </NavLink>
            <NavLink to="/standings" onClick={closeMenu}>
              Ställning
            </NavLink>
            <NavLink to="/rounds" onClick={closeMenu}>
              Rundor
            </NavLink>
            
            {/* Lägg till dropdown */}
            <div className="dropdown-container" ref={dropdownRef}>
              <button 
                className={`dropdown-toggle ${window.location.pathname.includes('/add-') ? 'active' : ''}`} 
                onClick={toggleDropdown}
              >
                <FaPlus /> Lägg till <FaChevronDown className={`dropdown-icon ${dropdownOpen ? 'open' : ''}`} />
              </button>
              
              {dropdownOpen && (
                <div className="dropdown-menu">
                  <NavLink to="/add-round" onClick={() => { closeMenu(); setDropdownOpen(false); }}>
                    <FaGolfBall /> Lägg till runda
                  </NavLink>
                  <NavLink to="/add-player" onClick={() => { closeMenu(); setDropdownOpen(false); }}>
                    <FaUser /> Lägg till spelare
                  </NavLink>
                  <NavLink to="/add-course" onClick={() => { closeMenu(); setDropdownOpen(false); }}>
                    <FaGolfBall /> Lägg till bana
                  </NavLink>
                </div>
              )}
            </div>
            
            <NavLink to="/players" onClick={closeMenu}>
              Spelare
            </NavLink>
          </nav>
          
          <div className="header-actions">
            <button 
              className="theme-toggle" 
              onClick={toggleTheme} 
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {theme === 'dark' ? <FaSun /> : <FaMoon />}
            </button>
          </div>
        </div>

        <button 
          className="mobile-menu-toggle"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={toggleMenu}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header; 